// The countries the app can follow. The dropdown sorts them by their translated name.
// i18nKey is the translation key of the country's name.
export const COUNTRIES = [
    { code: 'FIN', i18nKey: 'country_finland' },
    { code: 'SWE', i18nKey: 'country_sweden' },
    { code: 'CZE', i18nKey: 'country_czechia' },
    { code: 'CAN', i18nKey: 'country_canada' },
    { code: 'USA', i18nKey: 'country_usa' },
    { code: 'RUS', i18nKey: 'country_russia' },
    { code: 'DEU', i18nKey: 'country_germany' },
    { code: 'FRA', i18nKey: 'country_france' },
    { code: 'CHE', i18nKey: 'country_switzerland' },
    { code: 'SVK', i18nKey: 'country_slovakia' },
    { code: 'NOR', i18nKey: 'country_norway' },
    { code: 'DEN', i18nKey: 'country_denmark' },
    { code: 'LAT', i18nKey: 'country_latvia' },
] as const;

export type CountryCode = (typeof COUNTRIES)[number]['code'];

export const COUNTRY_CODES = COUNTRIES.map(country => country.code) as readonly CountryCode[];
